module.exports = {
      id: "canvas-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#canvas",
      toString: function () {
        return this.url;
      }
    }